module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "breadcrumb",
    attrs: {
      "aria-label": "breadcrumbs"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/clients"
    }
  }, [_vm._v("Applications")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": ("/clients/" + (this.$route.params.client_id))
    }
  }, [_vm._v(_vm._s(this.$store.state.client.name))])], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('nav', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "level-right"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('p', [_vm._v("Total: "), _c('strong', [_vm._v(_vm._s(_vm._f("numberDisplay")(this.$store.state.clientDevicesTotal)))]), _vm._v(" mobile devices")])])])]), _vm._v(" "), _c('pagination', {
    staticClass: "is-small",
    attrs: {
      "urlBuilder": _vm.buildPaginatorUrls,
      "currentPage": _vm.currentPage,
      "lastPage": _vm.lastPage,
      "displayPage": 5
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table is-striped is-fullwidth"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [(!this.$store.state.clientDevices.length) ? _c('tr', [_c('td', {
    staticClass: "has-text-centered has-text-grey",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("No mobile devices found")])]) : _vm._e(), _vm._v(" "), _vm._l((this.$store.state.clientDevices), function(item) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.model))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.manufacturer))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.platform_ver))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.updated_at))])])
  })], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "is-active"
  }, [_c('a', {
    attrs: {
      "href": "#",
      "aria-current": "page"
    }
  }, [_vm._v("Mobile devices")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("ID")]), _vm._v(" "), _c('th', [_vm._v("Model")]), _vm._v(" "), _c('th', [_vm._v("Manufacturer")]), _vm._v(" "), _c('th', [_vm._v("Platform")]), _vm._v(" "), _c('th', [_vm._v("Version")]), _vm._v(" "), _c('th', [_vm._v("Created at")]), _vm._v(" "), _c('th', [_vm._v("Updated at")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81f71f18"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Devices/DeviceList.vue
// module id = 222
// module chunks = 1